<template>
  <header class="site-header">
    <div class="container">
      <div class="header-top">
        <div class="logo-container">
          <router-link to="/" class="logo">
            <img src="@/assets/images/phonelogo.png" alt="广州市劳动保障学会 Logo">
          </router-link>
        </div>
        <div class="header-search">
          <input
            type="text"
            v-model="searchKeyword"
            placeholder="请输入搜索内容"
            class="search-input"
            @keyup.enter="goSearch"
          >
          <button class="search-btn" @click="goSearch">搜索</button>
        </div>
      </div>
      <nav class="main-nav">
        <ul class="nav-list">
          <li class="nav-item">
            <router-link to="/" class="nav-link" exact-active-class="active">网站首页</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/about" class="nav-link" active-class="active">学会简介</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/news" class="nav-link" active-class="active">新闻资讯</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/policy" class="nav-link" active-class="active">政策法规</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/dynamics" class="nav-link" active-class="active">学会动态</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/courses" class="nav-link" active-class="active">培训考证</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/recruitment" class="nav-link" active-class="active">人才招聘</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/case-law" class="nav-link" active-class="active">以案释法</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/experts" class="nav-link" active-class="active">专家团队</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/membership" class="nav-link" active-class="active">入会申请</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/member-services" class="nav-link" active-class="active">会员服务</router-link>
          </li>
          <li class="nav-item">
            <a href="https://jndj.osta.org.cn/" target="_blank" rel="noopener noreferrer" class="nav-link">证书查询</a>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      searchKeyword: ''
    }
  },
  methods: {
    goSearch() {
      const keyword = this.searchKeyword.trim()
      if (!keyword) return
      this.$router.push({
        path: '/search',
        query: { keyword }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.site-header {
  background-color: #fff;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 100;
  padding-bottom: 0;
  
  .header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
  }
  
  .logo-container {
    display: flex;
    justify-content: center;
  }
  
  .logo {
    display: flex;
    align-items: center;
    text-decoration: none;
    
    img {
      max-width: 320px;
      height: auto;
      transition: transform 0.3s;
      
      &:hover {
        transform: scale(1.02);
      }
    }
  }
  
  .header-search {
    display: flex;
    
    .search-input {
      width: 250px;
      padding: 10px 15px;
      border: 1px solid #ddd;
      border-right: none;
      border-radius: 4px 0 0 4px;
      outline: none;
      font-size: 14px;
      transition: all 0.3s;
      
      &:focus {
        border-color: #2d8cf0;
        box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.1);
      }
    }
    
    .search-btn {
      padding: 10px 20px;
      background-color: #2d8cf0;
      color: #fff;
      border: none;
      border-radius: 0 4px 4px 0;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.3s;
      
      &:hover {
        background-color: #1d7dd8;
      }
      
      &:active {
        background-color: #1a6fc0;
        transform: translateY(1px);
      }
    }
  }
  
  .main-nav {
    background-color: #2d8cf0;
    border-radius: 4px 4px 0 0;
    margin-bottom: -3px;
    width: 100%;
    
    .nav-list {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0;
      flex-wrap: nowrap;
      width: 100%;
    }
    
    .nav-item {
      position: relative;
      flex: 1;
      
      &:first-child .nav-link {
        border-radius: 4px 0 0 4px;
      }
      
      &:last-child .nav-link {
        border-radius: 0 4px 4px 0;
      }
      
      .nav-link {
        display: block;
        padding: 15px 10px;
        color: #fff;
        font-size: 16px;
        text-decoration: none;
        transition: all 0.3s;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        
        &:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }
        
        &.active {
          background-color: #1d7dd8;
          font-weight: 500;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) inset;
        }
      }
    }
  }
  
  @media (max-width: 1200px) {
    .main-nav {
      .nav-item .nav-link {
        font-size: 15px;
        padding: 15px 8px;
      }
    }
  }
  
  @media (max-width: 992px) {
    .header-top {
      flex-direction: column;
      
      .logo-container {
        margin-bottom: 15px;
      }
      
      .logo img {
        max-width: 280px;
      }
    }
    
    .main-nav {
      .nav-list {
        flex-wrap: wrap;
        justify-content: space-between;
      }
      
      .nav-item {
        width: 25%;
        flex: none;
        
        .nav-link {
          padding: 12px 5px;
          font-size: 14px;
          
          &:hover {
            background-color: rgba(0, 0, 0, 0.1);
          }
        }
        
        &:first-child .nav-link,
        &:last-child .nav-link {
          border-radius: 0;
        }
      }
    }
  }
  
  @media (max-width: 768px) {
    .main-nav {
      .nav-item {
        width: 33.333%;
      }
    }
    
    .logo img {
      max-width: 250px;
    }
  }
  
  @media (max-width: 576px) {
    .main-nav {
      .nav-item {
        width: 50%;
      }
    }
    
    .header-search {
      width: 100%;
      
      .search-input {
        flex: 1;
      }
    }
    
    .logo img {
      max-width: 220px;
    }
  }
  
  @media (max-width: 400px) {
    .logo img {
      max-width: 180px;
    }
  }
}
</style> 